import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgYoutube = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 25,
	viewBox: "0 0 24 25",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M23.7609 7.70078C23.7609 7.70078 23.5266 6.04609 22.8047 5.31953C21.8906 4.36328 20.8688 4.35859 20.4 4.30234C17.0438 4.05859 12.0047 4.05859 12.0047 4.05859H11.9953C11.9953 4.05859 6.95625 4.05859 3.6 4.30234C3.13125 4.35859 2.10938 4.36328 1.19531 5.31953C0.473438 6.04609 0.24375 7.70078 0.24375 7.70078C0.24375 7.70078 0 9.64609 0 11.5867V13.4055C0 15.3461 0.239062 17.2914 0.239062 17.2914C0.239062 17.2914 0.473437 18.9461 1.19062 19.6727C2.10469 20.6289 3.30469 20.5961 3.83906 20.6992C5.76094 20.882 12 20.9383 12 20.9383C12 20.9383 17.0438 20.9289 20.4 20.6898C20.8688 20.6336 21.8906 20.6289 22.8047 19.6727C23.5266 18.9461 23.7609 17.2914 23.7609 17.2914C23.7609 17.2914 24 15.3508 24 13.4055V11.5867C24 9.64609 23.7609 7.70078 23.7609 7.70078ZM9.52031 15.6133V8.86797L16.0031 12.2523L9.52031 15.6133Z",
		fill: "white"
	})
});
export default SvgYoutube;
